import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../brand/Logo';
import { categories } from '../../data/categories';
import { navItems } from '../../data/site';
import { useBrand } from '../../contexts/BrandContext';
export function Footer() {
  const {
    brand,
    text
  } = useBrand();
  return <footer className="bg-ink text-cream" data-id="element-199" data-mp="5nvos5k8efia">
      <div className="mx-auto max-w-shell px-6 py-16 md:px-8 md:py-20" data-id="element-200" data-mp="5msvjqzfs0z7">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]" data-id="element-201" data-mp="orh5jcygpu2">
          <div data-id="element-202" data-mp="3s259o4oyd5eb">
            <Logo className="text-xl text-copper" withTagline data-id="element-203" data-mp="3s1m3tmcku7gn" />
            <p className="mt-8 max-w-xs text-base leading-relaxed text-cream/70" data-id="element-204" data-mp="3n3kcke4zz1u3">
              Real doctors, real bloodwork, and a price you can see coming. That is the whole idea.
            </p>
          </div>

          <FooterColumn title="Shop" data-id="element-205" data-mp="3e3fe4ths7ds2">
            {categories.map(category => <FooterLink key={category.slug} to={`/categories/${category.slug}`} data-id="element-206" data-mp="393t40sx92dnh">
                {category.name}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title={brand.name} data-id="element-207" data-mp="2kba0hbf35i64">
            {navItems.map(item => <FooterLink key={item.to} to={item.to} data-id="element-208" data-mp="2p54imaf1lp33">
                {item.label}
              </FooterLink>)}
          </FooterColumn>

          <FooterColumn title="Members" data-id="element-209" data-mp="2gazwg4aut1tw">
            <FooterLink to="/get-started" data-id="element-210" data-mp="2gbrgchv39b4c">Get started</FooterLink>
            <FooterLink to="/labs" data-id="element-211" data-mp="340u84ijfskck">Book bloodwork</FooterLink>
            <FooterLink to="/pricing" data-id="element-212" data-mp="382p7hhht4nnp">What it costs</FooterLink>
            <FooterLink to="/about" data-id="element-213" data-mp="3825pk0s5pz9o">Our promises</FooterLink>
          </FooterColumn>
        </div>

        <div className="rule-light mt-14 pt-8" data-id="element-214" data-mp="2u2eea7t0ywzd">
          <p className="max-w-4xl text-xs leading-relaxed text-cream/55" data-id="element-215" data-mp="2z1r32y3gie4l">
            {text('Republic is a direct-pay medical practice. Treatment is prescribed only where a licensed doctor judges it appropriate after reviewing your history and labs. Compounded medications are not FDA-approved products and are made by US-licensed 503A and 503B pharmacies. This site is for general information and is not a substitute for advice about your own health.')}
          </p>
          <div className="mt-8 flex flex-col gap-4 text-xs text-cream/55 sm:flex-row sm:items-center sm:justify-between" data-id="element-216" data-mp="us5yynt7s1ii">
            <p data-id="element-217" data-mp="pu4bzrso3i1r">
              © {new Date().getFullYear()} {brand.copy.legalName}
            </p>
            <div className="flex gap-6" data-id="element-218" data-mp="kuhzxloks7uj">
              <Link to="/about" className="transition-colors hover:text-copper" data-id="element-219" data-mp="ks5a6mckst6x">
                Privacy
              </Link>
              <Link to="/about" className="transition-colors hover:text-copper" data-id="element-220" data-mp="btjxh7tsc8e2">
                Terms
              </Link>
              <Link to="/about" className="transition-colors hover:text-copper" data-id="element-221" data-mp="6v8mgtrr7ru9">
                HIPAA notice
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}
function FooterColumn({
  title,
  children
}: {
  title: string;
  children: React.ReactNode;
}) {
  return <div data-id="element-222" data-mp="28qzchbqlfsez">
      <h2 className="text-[0.6875rem] uppercase tracking-label text-copper" data-id="element-223" data-mp="28r7ol1ew6tp4">{title}</h2>
      <ul className="mt-6 flex flex-col gap-3" data-id="element-224" data-mp="2dq27028y6g8p">{children}</ul>
    </div>;
}
function FooterLink({
  to,
  children
}: {
  to: string;
  children: React.ReactNode;
}) {
  return <li data-id="element-225" data-mp="2ngnd0aqyan1n">
      <Link to={to} className="text-sm text-cream/75 transition-colors duration-150 ease-republic hover:text-cream" data-id="element-226" data-mp="2nhexoqj0f0d5">
        {children}
      </Link>
    </li>;
}